<template>
  <div>
    <div class='h-dialogContainer'>
      <div class='row h-row-inputBox'>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>环境名称:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" placeholder='DP' v-model="dpName">
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>环境IP:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" placeholder='IP' v-model="dpIp">
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>用户名:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" placeholder='Admin' v-model="userName">
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>环境端口:</div>
          <div class="input-group">
            <input type="text" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" placeholder='8080' v-model="dpPort">
        </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>密码:</div>
          <div class="input-group">
            <input type="password" :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" placeholder='XXXXX' v-model="password">
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>产品:</div>
          <div class="input-group">
            <ejs-dropdownlist id="product" :fields = "fields" :index = "currentIndex" :dataSource = "productItems" :popupHeight= "popupHeight" v-model='product'>
            </ejs-dropdownlist>
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>模板形态:</div>
          <div class="input-group">
            <ejs-dropdownlist id="deploymentNorm" :fields = "fields" :index = "currentIndex" :dataSource = "templateItems" :popupHeight= "popupHeight" v-model='deploymentNorm'>
            </ejs-dropdownlist>
          </div>
        </div>
        <div class="col-sm-6 control-section default-sample">
          <div class="control_wrapper">
            <ejs-uploader ref="uploadObj" id='defaultfileupload' name="defaultfileupload" :selected="onFileSelect" allowedExtensions=".xml" :multiple="false"
                          :autoUpload='isAuto' :enabled="enabled"></ejs-uploader>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
import { EventBus } from '../../../../../plugins/eventBus';

Vue.use(TextBoxPlugin);
Vue.use(UploaderPlugin);
export default {
  name: 'AddDPEnviroment',
  components: {
  },
  data() {
    return {
      dpName: '',
      dpIp: '',
      dpPort: '',
      userName: '',
      password: '',
      product: 0,
      deploymentNorm: 0,
      productItems: [
        { sizeVal: 0, sizeTxt: '3000' },
        { sizeVal: 1, sizeTxt: '6000' },
        { sizeVal: 2, sizeTxt: '9000' },
      ],
      templateItems: [
        { sizeVal: 0, sizeTxt: '单机单点' },
        { sizeVal: 1, sizeTxt: '单机集群' },
        { sizeVal: 2, sizeTxt: '单主多从最小规格' },
        { sizeVal: 3, sizeTxt: '单主多从中等规格' },
        { sizeVal: 4, sizeTxt: '单主多从大型规格' },
        { sizeVal: 5, sizeTxt: '双主多从最小规格' },
        { sizeVal: 6, sizeTxt: '双主多从中等规格' },
        { sizeVal: 7, sizeTxt: '双主多从大型规格' }
      ],
      fields: { text: 'sizeTxt', value: 'sizeVal' },
      popupHeight: 200,
      currentIndex: 0,
      path: {
        saveUrl: 'http://localhost:8080/lte/ems/env/upload.html',
        removeUrl: 'http://localhost:8080/lte/ems/env/delDeployTemplate.html'
      },
      isAuto: true,
      enabled: true
    };
  },
  methods: {
    onFileSelect(args) {
      const file = args.filesData;
      if (file[0].name.indexOf('.xml') === -1) {
        EventBus.$emit('toast', { type: 'warning', content: '请上传xml文件' });
        return null;
      }
      this.addTemplate();
    },
    addTemplate() {
      const url = '/lte/ems/env/upload';
      const formData = new FormData();
      const uploadFile = document.getElementById('defaultfileupload').files[0];
      formData.append('file', uploadFile);
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 60 * 6 * 1000
      };
      this.$loading.showLoadding(this.$t('System.uploadFile'), uploadFile.name);
      this.axios.post(url, formData, config).then(response => {
        if (response['data'].errorCode == 'SUCCESS') {
          EventBus.$emit('success', this.$t('Common.tips.success'));
        } else {
          EventBus.$emit('error', response['data'].errorString);
        }
        this.$loading.hideLoadding();
        // 解决组件添加相同文件不触发onFileSelect bug
        /* const element = document.getElementsByClassName('e-file-remove-btn')[0];
        element.click(); */
      });
    },
    getData() {
      /* if (this.dpName === '') {
        EventBus.$emit('toast', { type: 'warning', content: '名称不允许为空' })
        return;
      }
      if (this.enddate === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.endDateIsNull') })
        return;
      }
      if (this.neId === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.neIDIsNull') })
        return;
      }
      if (new Date(this.startdate).getTime() > new Date(this.enddate).getTime()) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateGreaterEndDate') })
        return;
      }
      if ((this.timeInterval === 0 || this.timeInterval === 1) && (new Date(this.startdate).getTime() !== new Date(this.enddate).getTime())) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateEqualsEndDate') })
        return;
      }
      if (this.timeInterval === 2 && new Date(this.startdate).getTime() === new Date(this.enddate).getTime()) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateNoEqualsEndDate') })
        return;
      }
      if (new Date(this.enddate).getTime() - new Date(this.startdate).getTime() > 2678400000) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateMaxEndDate') })
        return;
      } */
      const fileName = (this.$refs.uploadObj.getFilesData().length === 0) ? '' : this.$refs.uploadObj.getFilesData()[0].name;
      return {
        name: this.dpName,
        type: 'DP',
        content: {
          dpIp: this.dpIp,
          dpPort: this.dpPort,
          userName: this.userName,
          password: this.password,
          product: this.product,
          deploymentNorm: this.deploymentNorm
        },
        deploymentTemplate: fileName
      };
    }
  },
  computed: {

  }
};
</script>
<style scoped>

</style>
